import { createSlice, PayloadAction } from '@reduxjs/toolkit';


const initialState: any = {
  screenWidth: 0
};

export const screenWidthSlice = createSlice({
  name: 'screenWidth',
  initialState,
  reducers: {
    setScreenWidth: (state, action: PayloadAction<number>) => {
      state.screenWidth = action.payload;
    }
  }
});

export const { setScreenWidth } = screenWidthSlice.actions;

export default screenWidthSlice.reducer;
